import { Injectable } from '@angular/core';
import { Calendar, User } from '../classes';

/**
 * @deprecated
 */
@Injectable({
  providedIn: 'root'
})
export class AppStateService {

  currentEMails: string[] = [];

  objectCache: any = {  };

  calendars: Calendar[] = [];

  users: User[] = [];

  productsMap: { [key: number]: string } = { };
  
  constructor() { }
}